export const PRODUCTION_APP_ID = '36544';
export const STAGING_APP_ID = '36545';
export const VERCEL_DEPLOYMENT_APP_ID = '35073';
export const LOCALHOST_APP_ID = '35074';
export const PRODUCTION_ME_APP_ID = '61569';
export const PRODUCTION_BE_APP_ID = '61570';
export const STAGING_ME_APP_ID = '61571';
export const STAGING_BE_APP_ID = '61572';

export const DEFAULT_WS_SERVER = 'ws.derivws.com';
export const OAUTH_URL = 'oauth.deriv.com';

export const LOGIN_ACCOUNTS_SESSION_STORAGE_KEY = 'login-accounts';
export const CURRENT_LOGIN_ACCOUNT_SESSION_STORAGE_KEY = 'current-login-account';
export const USER_SESSION_STORAGE_KEY = 'user';
export const USER_ACCOUNTS_SESSION_STORAGE_KEY = 'user-accounts';
